// TODO: Constants

export const CHALLENGES_TABLE_HEADERS = [];

export const MAX_NAME_LENGTH = 30;
export const MAX_TITLE_LENGTH = 30;
export const MAX_DESCRIPTION_LENGTH = 100;
